import { OnboardingScreenInterests } from '../screens/Interests';

import { ScreenAICharacteristic } from './screens/AICharacteristic';
import { ScreenAppUsers } from './screens/AppUsers';
import { ScreenChatExample } from './screens/ChatExample';
import { ScreenCreatingProfile } from './screens/CreatingProfile';
import { ScreenEmail } from './screens/Email';
import { ScreenLoneliness } from './screens/Loneliness';
import { ScreenLonelinessGraph } from './screens/LonelinessGraph';
import { ScreenName } from './screens/Name';
import { ScreenPreferences } from './screens/Preferences';
import { ScreenSecurity } from './screens/Security';
import { ScreenTopics } from './screens/Topics';
import { LayoutDataType } from './types';

export const layoutSteps = {
  preferences: ScreenPreferences,
  topics: ScreenTopics,
  appusers: ScreenAppUsers,
  interests: OnboardingScreenInterests,
  ai_characteristic: ScreenAICharacteristic,
  security: ScreenSecurity,
  name: ScreenName,
  chat_example: ScreenChatExample,
  loneliness: ScreenLoneliness,
  loneliness_graph: ScreenLonelinessGraph,
  creating: ScreenCreatingProfile,
  email: ScreenEmail,
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  ai_characteristic: 'Neutral',
  categories: [],
  characters: [],
  email: '',
  interests: [],
  loneliness: null,
  name: '',
  preloadCategories: [],
  topics: '',
  createdUser: false,
};
